import { render, staticRenderFns } from "./OnboardingBuyer.vue?vue&type=template&id=115d1a3a"
import script from "./OnboardingBuyer.vue?vue&type=script&lang=js"
export * from "./OnboardingBuyer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports